import { GameId } from '@common'
import Image from 'next/image'

import { useGameImages } from '@/components/games/images'
import { Cross } from '@/components/Icons'
import { useAppSelector } from '@/utils/useAppSelector'

import { useModalContext } from '../../../../contexts/ModalContext'
import { gameNames } from '../constants'
import { StoreTypography } from '../typography/StoreTypography'

import styles from './bonusInfo.module.scss'

export const BonusInfo = () => {
  const gameSlug = useAppSelector((state) => state.common.currentGame) as GameId
  const { gameImage } = useGameImages(gameSlug)
  const { closeModal } = useModalContext()

  const gameSpecificText = `Every purchase you make in the ${gameNames[gameSlug]} Store earns you points towards your next Store Bonus.`

  return (
    <div className={styles.bonusInfo}>
      <div className={styles.closeOverlay} onClick={closeModal}>
        <Cross />
      </div>
      <div className={styles.bonusInfoHero}>
        <div className={styles.logoContainer}>
          <Image src={gameImage('logo')} alt="bonus info" fill style={{ objectFit: 'contain' }} />
        </div>
        <Image src={gameImage('heroMobile')} alt="bonus info" fill style={{ objectFit: 'cover' }} />
      </div>
      <div className={styles.bonusText}>
        <StoreTypography tag="p" style="plain" textSize="body" overrideFont="supercellText" lineHeight="normal">
          {gameSpecificText}
        </StoreTypography>
        <StoreTypography tag="p" style="plain" textSize="body" overrideFont="supercellText" lineHeight="normal">
          Want extra points? Complete the challenges listed in the Bonus Track.
        </StoreTypography>
        <StoreTypography tag="p" style="plain" textSize="body" overrideFont="supercellText" lineHeight="normal">
          Each season there is a new track of bonuses to earn. Any unclaimed bonuses will be available to claim for one
          additional season.
        </StoreTypography>
      </div>
    </div>
  )
}
